import PropTypes from 'prop-types';
import {createUseStyles, useTheme} from 'react-jss';
import {connect} from 'react-redux';
import Legend from '../../../../components/Accessibility/Legend/Legend';
import Translation from '../../../../v2/lang/Translation';
import {isPudoAvailable} from '../../../../v2/selectors/selectors';
import Spacing from '../../../../v2/style-helper/Spacing';
import EmailAddress from '../EmailAddress';

const useStyles = createUseStyles({
  emailAddressWrapper: {
    marginTop: props => (props.showCollapsedEmailAddress && Spacing.double),
    // eslint-disable-next-line no-nested-ternary
    marginBottom: props => (props.showCollapsedEmailAddress ? Spacing.single : (props.isPudoAvailable ? Spacing.triple : Spacing.single)),
  },
  legend: props => props.showCollapsedEmailAddress && {
    color: '#333',
    fontWeight: props.theme.core.boldFontWeight,
  },
});

export function EmailAddressWrapper(props) {
  const theme = useTheme();
  const classes = useStyles({...props, theme});
  return (
    <div className={classes.emailAddressWrapper}>
      <fieldset className="EmailAddress">
        <div className={classes.legend}>
          <Legend hidden={!props.showCollapsedEmailAddress}>
            <Translation>email.address</Translation>
          </Legend>
        </div>
        {props.showCollapsedEmailAddress ? (
          <p data-cs-mask>{props.emailAddress}</p>
        ) : (
          <EmailAddress emailAddress={props.emailAddress} />
        )}
      </fieldset>
    </div>
  );
}

EmailAddressWrapper.propTypes = {
  showCollapsedEmailAddress: PropTypes.bool.isRequired,
  emailAddress: PropTypes.bool,
  isPudoAvailable: PropTypes.bool.isRequired,
};

EmailAddressWrapper.defaultProps = {
  emailAddress: '',
};

const mapStateToProps = state => ({
  emailAddress: state.email.emailAddress,
  isPudoAvailable: isPudoAvailable(state),
});

export default connect(mapStateToProps)(EmailAddressWrapper);
